import { render, staticRenderFns } from "./TagManagement.vue?vue&type=template&id=ce7e10ce&"
import script from "./TagManagement.vue?vue&type=script&lang=js&"
export * from "./TagManagement.vue?vue&type=script&lang=js&"
import style0 from "./TagManagement.vue?vue&type=style&index=0&id=ce7e10ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports